<div class="profile flex__child--auto flex--column has-toolbar" data-test="settings">
  <mat-toolbar>
    <span class="mat-toolbar__title text--primary">{{ 'app.settings' | translate }}</span>
  </mat-toolbar>
  <app-settings-navigation></app-settings-navigation>
  <div [@routeAnimations]="getState(o)">
    <router-outlet #o="outlet"></router-outlet>
  </div>
</div>
